import { useReducer, useEffect } from 'react'
import api from 'api/paths'
import reducer, { ReducerState, ReducerAction } from 'api/load-reducer'

export interface Partner {
  image: string
  link?: string
}
export const initialState: ReducerState<Partner[]> = {
  isLoading: false,
  data: [],
}
type PartnersReducer = (
  state: ReducerState<Partner[]>,
  action: ReducerAction<Partner[]>
) => ReducerState<Partner[]>

const usePartners = () => {
  const [state, dispatch] = useReducer(reducer as PartnersReducer, initialState)

  const getData = async () => {
    dispatch({ type: 'LOAD' })
    const response = await fetch(`${api.baseUrl}${api.paths.partners}`)
    try {
      if (!response.ok) throw new Error(response.status.toString())
      const json = await response.json()
      dispatch({ type: 'SUCCESS', payload: json })
    } catch (err) {
      dispatch({ type: 'ERROR' })
    }
  }

  useEffect(() => {
    getData()
  }, [])

  return [state, getData] as const
}

export default usePartners
